import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import 'react-phone-input-material-ui/lib/style.css'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';


ReactDOM.render(
  <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
